import styled from 'styled-components'

export const Container = styled.div`
  padding-bottom: ${props => props.theme.spacing.sp16};
`
